import React from "react"

export const NoEventsMessage: React.FC = () => {
    return (
        <div className="p-1 py-2 my-1 text-muted d-flex justify-content-center small">
            {"No events added yet"}
        </div>
    )
}
